<template>
  <div class="blog-detail-container" ref="blogContainer">
    <h1>{{ blogContent.title }}</h1>
    <div class="blog-detail-label">
      <span>日期:{{ timestampToDateTime(+blogContent.createDate) }}</span>
      <span>浏览:{{ blogContent.scanNumber }}</span>
      <a href="#user-comment" class="comment-link">评论:{{ blogContent.commentNumber }}</a>
      <router-link :to="{
        name: 'BlogCategory', params: {
          categoryId: blogContent.category.id
        }
      }" class="category-link">分类{{ blogContent.category.id
}}</router-link>
    </div>
    <div class="blog-content-area markdown-body" v-html="blogContent.htmlContent">
    </div>
    <div class="post-comment-area" id="user-comment" ref="container">
      <div class="input-name">
        <input type="text" placeholder="用户昵称" v-model="commentForm.nickname" @blur="handleChangeName($event.target.value)"
          @input="handleNameWord($event.target.value)" maxlength="10">
        <div class="name-prompt">{{ wordLength }}/10</div>
        <div class="name-info" v-if="nameInfo">请填写昵称</div>
      </div>
      <div class="input-content">
        <!-- <input type="text" placeholder="输入内容" v-model="commentForm.content"
          @blur="handleChangeContent($event.target.value)"> -->
        <textarea placeholder="输入内容" v-model="commentForm.content" @blur="handleChangeContent($event.target.value)"
          class="textarea"></textarea>
        <div class="content-info" v-if="contentInfo">请输入内容</div>
      </div>
      <button class="comment-btn" @click="handleSubmit" :disabled="isSubmit">提交</button>
    </div>
    <div class="user-comment-area" v-if="commentList">
      <div class="comment-total">列表评论({{ commentList.total }})</div>
      <div class="user-comment-area">
        <div v-for="item in commentList.rows" :key="item.id" class="comment-item">
          <div class="comment-img">
            <img :src="item.avatar" alt="">
          </div>
          <div class="userInfo-content">
            <div class="nickname">
              <span>{{ item.nickname }}</span>
              <span class="nickname-date">{{ timestampToComplectTime(+item.createDate) }}</span>
            </div>
            <div class="comment-content">{{ item.content }}</div>
          </div>
        </div>
      </div>
      <div class="isLoading" v-loading="isLoading"></div>
    </div>
  </div>
</template>

<script>
import { postComment } from '@/api/comment';
import { getComment } from '@/api/comment';
import showMessage from '@/utils/showMessage';
import eventBus from '@/eventBus';
export default {
  props: ['blogContent'],
  data() {
    return {
      scrollPosition: 0,
      isSubmit: false,
      commentForm: {
        nickname: '',
        content: "",
        blogId: this.$route.params.id,
      },
      commentList: null,
      nameInfo: false,
      contentInfo: false,
      wordLength: 0,
      page: 1,
      limit: 10,
      isLoading: false,
    }
  },
  created() {
    getComment(this.page, this.limit).then(r => {
      this.commentList = r.data.data
    })
  },
  mounted() {
    eventBus.$on('setScrollTop', this.handleToTop);
    eventBus.$emit('mainScroll', this.$refs.blogContainer); //列表滚动事件
    this.$refs.blogContainer.addEventListener('scroll', this.handleContentScroll)//列表滚动事件
    this.$refs.blogContainer.addEventListener('scroll', this.getMorelist)//评论滚动事件
  },
  beforeDestroy() {
    eventBus.$off('setScrollTop', this.handleToTop);
    eventBus.$emit('mainScroll');//告诉事件总线其他处理函数 dom已经销毁
    this.$refs.blogContainer.removeEventListener('scroll', this.handleContentScroll)
    this.$refs.blogContainer.removeEventListener('scroll', this.getMorelist)
  },
  methods: {
    timestampToDateTime(timestamp) {
      const CurTimestamp = Number(timestamp);
      var date = new Date(CurTimestamp);
      // // 提取年、月、日、时、分、秒
      var year = date.getFullYear();
      var month = (date.getMonth() + 1).toString().padStart(2, '0'); // 月份加1并补0
      var day = date.getDate().toString().padStart(2, '0'); // 补0
      // 格式化时间字符串
      var dateTimeString = year + '-' + month + '-' + day + ' ';
      // 返回格式化后的时间字符串
      return dateTimeString;
    },
    timestampToComplectTime(timestamp) {
      const CurTimestamp = Number(timestamp);
      var date = new Date(CurTimestamp);
      // // 提取年、月、日、时、分、秒
      var year = date.getFullYear();
      var month = (date.getMonth() + 1).toString().padStart(2, '0'); // 月份加1并补0
      var day = date.getDate().toString().padStart(2, '0'); // 补0
      var hour = date.getHours();
      var minute = date.getMinutes();
      var second = date.getSeconds();
      if (second < 10) {
        second = "0" + second
      }
      if (minute < 10) {
        minute = "0" + minute
      }
      if (hour < 10) {
        hour = "0" + hour
      }
      // 格式化时间字符串
      var dateTimeString = year + '-' + month + '-' + day + '   ' + hour + ':' + minute + ':' + second;
      // 返回格式化后的时间字符串
      return dateTimeString;
    },
    handleSubmit() {
      this.isSubmit = true;
      postComment(this.commentForm).then(r => {
        if (this.commentForm.nickname && this.commentForm.content && this.commentForm.blogId) {
          this.commentList.rows.unshift(r.data.data)
          showMessage({ type: 'chenggong', content: '评论成功', container: this.$refs.container });
          this.commentList.total++;
          this.commentForm.nickname = '';
          this.commentForm.content = '';
          this.wordLength = 0;
          this.isSubmit = false;
        } else {
          showMessage({ type: 'cuowu', content: '评论失败，请输入完整评论', container: this.$refs.container })
          this.commentForm.nickname = '';
          this.commentForm.content = '';
          this.wordLength = 0;
          this.isSubmit = false;
          return;
        }
      })
    },
    handleChangeName(info) {
      if (!info) {
        this.nameInfo = true;
        return
      } else {
        this.nameInfo = false
        return
      }
    },
    handleChangeContent(content) {
      if (!content) {
        this.contentInfo = true;
        return
      } else {
        this.contentInfo = false
        return
      }
    },
    handleNameWord(word) {
      if (word.length > 10) {
        // this.$refs.input.style.readonly = true
        return
      } else {
        this.wordLength = word.length
      }
    },
    getMorelist(dom) {
      if (!this.commentList || this.isLoading === true) {
        return
      }
      if (dom) {
        if (Math.abs(dom.target.scrollHeight - dom.target.clientHeight - dom.target.scrollTop) < 200) {
          if (this.commentList.rows.length >= this.commentList.total) {
            return
          }
          //已经滑到最低部
          this.isLoading = true
          this.page++;
          getComment(this.page, this.limit).then(r => {
            this.commentList.rows = this.commentList.rows.concat(r.data.data.rows)
            this.isLoading = false
          })
        }
      }
    },
    handleContentScroll() {
      eventBus.$emit('mainScroll', this.$refs.blogContainer)
    },
    handleToTop(num) {
      if (!this.$refs.blogContainer) {
        return
      }
      this.$refs.blogContainer.scrollTop = num;
      eventBus.$emit('handleAnchor', '')
    }
  }
}
</script>

<style lang="less" scoped>
@import url('./markdown.css');
@import "highlight.js/styles/github.css";



.blog-detail-container {
  scroll-behavior: smooth;
  box-sizing: border-box;
  padding: 0 30px;
  overflow-y: scroll;
}

.blog-detail-label {
  font-size: 10px;
  padding-top: 5px;
  color: #999;
  letter-spacing: 1px;

  span {
    margin-right: 7px;
  }
}

.blog-content-area {
  margin-top: 15px;
}

.post-comment-area {
  width: 100%;
  margin-top: 30px;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;

  .input-name {
    width: 50%;
    height: 40px;
    position: relative;

    input {
      width: 100%;
      height: 100%;
      border-style: dashed;
      padding-left: 10px;
      font-size: 16px;
    }
  }

  .input-content {
    margin-top: 30px;
    width: 100%;
    height: 200px;

    .textarea {
      display: block;
      box-sizing: border-box;
      width: 100%;
      height: 100%;
      border-style: dashed;
      font-size: 14px;
      padding: 5px 5px;
      resize: none;
    }
  }

  .comment-btn {
    margin-top: 30px;
    width: 100px;
    height: 40px;
    background: rgb(0, 0, 180);
    font-size: 14px;
    color: #fff;
    border-radius: 7px;
    cursor: pointer;
  }

  .comment-btn[disabled] {
    cursor: not-allowed;
    opacity: 0.5;
  }
}

.user-comment-area {
  width: 100%;
  margin-top: 30px;

  .comment-total {
    font-weight: bolder;
    font-size: 18px;
  }

  .user-comment-area {
    width: 100%;
  }

  .comment-img {
    width: 50px;
    height: 50px;
    margin-right: 15px;

    img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
  }

  .nickname-date {
    position: absolute;
    right: 20px;
    font-size: 12px;
    color: #999;
  }

  .comment-item {
    display: flex;
    width: 100%;
    border-bottom: 1px solid #999;
    box-sizing: border-box;
    padding: 20px 0;
  }

  .userInfo-content {
    width: 100%;

    .nickname {
      color: #009900;
      font-weight: bolder;
      position: relative;
    }

    .comment-content {
      margin-top: 12px;
      font-size: 14px;
    }
  }
}

.comment-link {
  text-decoration: none;
  color: #999;
  margin-right: 5px;
}

.comment-link:hover {
  color: #00008B;
}

.name-info,
.content-info {
  color: rgb(240, 0, 0);
}

.name-prompt {
  position: absolute;
  right: 0;
  bottom: 0;
  color: #999;
  font-size: 12px;
}

.category-link {
  text-decoration: none;
  color: #999;
}

.category-link:hover {
  color: #00008B;
}

.isLoading {
  position: relative;
  width: 100%;
  height: 80px;
}
</style>